import StackComponent from './Stack.vue';
export const Stack = StackComponent;
export default Stack;
